import { FormattedMessage } from '@flipster/i18n';
import Formatted from '@flipster/react/design-utils/formatted';
import CaretDownIcon from '@flipster/react/icon/generated/CaretDownIcon';
import CaretUpIcon from '@flipster/react/icon/generated/CaretUpIcon';
import { css, cx } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

export const RankChangeToday = ({ className, delta }: { className?: string; delta: number }) => {
  // ex) 20위 -> 4위로 오를 경우 서버에서 delta 값이 -16으로 내려오기 때문에 UI에서 정확한 표기를 위해서 부호를 뒤집어야함
  const rankChange = -1 * delta;

  return (
    <span
      className={cx(
        hstack({
          h: 23,
          gap: 2,
          bg: 'background.default.level-1',
          rounded: 999,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'border.default.level-1',
          p: '4px 8px',
          zIndex: 1,
        }),
        className,
      )}
    >
      {rankChange !== 0 && (
        <span className={hstack()}>
          {rankChange > 0 ? (
            <CaretUpIcon size={12} color={token('colors.content.state.positive')} />
          ) : (
            <CaretDownIcon size={12} color={token('colors.content.state.negative')} />
          )}
          <Formatted.Number
            value={rankChange}
            withColor
            css={{ textStyle: 'Text/XS/Regular' }}
            withPlus={rankChange > 0}
          />
        </span>
      )}
      <span className={css({ color: 'content.default.level-2', textStyle: 'Text/XS/Regular' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Today' />
      </span>
    </span>
  );
};
